'use strict';

angular.module('cloudBillingLegacyFrontend').service('$cbBackend', function($http, $eaConfig, $eaBackendBase) {
    var self = this;    
    
    var apiHostCloudBilling = $eaConfig.getConfiguration().apiHost.replace('cb1', 'cloudbilling');
    var backendUri  = ($eaConfig.getConfiguration().apiProtocol ? $eaConfig.getConfiguration().apiProtocol : 'https') + '://' + apiHostCloudBilling + '/api/v1';
    var frontendCBUri = ($eaConfig.getConfiguration().apiProtocol ? $eaConfig.getConfiguration().apiProtocol : 'https') + '://' + apiHostCloudBilling;

    self.dataGetPreferedApplication = function(contactAddress, dataToken) {
      return $eaBackendBase.extractDataFromResponse($http.get(backendUri + '/environment/users/' + contactAddress, {headers: $eaBackendBase.getDefaultHeaders(dataToken)})).then(function(result) {
        /*jshint sub:true*/
        result['target'] = frontendCBUri;
        return result;
      });
    };
});
